export var ITEMS = [{
  img: 'https://st-gdx.dancf.com/gaodingx/213/configs/system/20200907-110324-e3be.png',
  title: '微信/朋友圈',
  titleColor: '#32A88C',
  linkObjs: [{
    text: '长图海报',
    url: 'https://www.gaoding.com/templates/fcc1612535-fc1612533-f1612532'
  }, {
    text: '电子贺卡',
    url: 'https://www.gaoding.com/templates/fcc1612542-fc1612533-f1612532'
  }, {
    text: '日签',
    url: 'https://www.gaoding.com/templates/fcc1612537-fc1612533-f1612532'
  }, {
    text: '漫画海报',
    url: 'https://www.gaoding.com/templates/fcc1612546-fc1612533-f1612532'
  }, {
    text: '更多',
    url: 'https://www.gaoding.com/templates/fc1612533-f1612532'
  }]
}, {
  img: 'https://st-gdx.dancf.com/gaodingx/213/configs/system/20200907-105946-593a.png',
  title: '新媒体',
  titleColor: '#45A03D',
  linkObjs: [{
    text: '公众号首图',
    url: 'https://www.gaoding.com/templates/fcc1612548-fc1612547-f1612532'
  }, {
    text: '公众号次图',
    url: 'https://www.gaoding.com/templates/fcc1612549-fc1612547-f1612532'
  }, {
    text: '广告banner',
    url: 'https://www.gaoding.com/templates/fcc1612553-fc1612547-f1612532'
  }, {
    text: '课程封面',
    url: 'https://www.gaoding.com/templates/fcc1612554-fc1612547-f1612532'
  }, {
    text: '更多',
    url: 'https://www.gaoding.com/templates/fc1612547-f1612532'
  }]
}, {
  img: 'https://st-gdx.dancf.com/gaodingx/213/configs/system/20200907-105754-db66.png',
  title: '电商',
  titleColor: '#EC5534',
  linkObjs: [{
    text: '主图图标',
    url: 'https://www.gaoding.com/templates/fcc1612573-fc1612571-f1612532'
  }, {
    text: '胶囊banner',
    url: 'https://www.gaoding.com/templates/fcc1615056-fc1612571-f1612532'
  }, {
    text: '主图/直通车',
    url: 'https://www.gaoding.com/templates/fcc1613042-fc1612571-f1612532'
  }, {
    text: '详情页',
    url: 'https://www.gaoding.com/templates/fcc1612574-fc1612571-f1612532'
  }, {
    text: '更多',
    url: 'https://www.gaoding.com/templates/fc1612571-f1612532'
  }]
}, {
  img: 'https://st-gdx.dancf.com/gaodingx/213/configs/system/20200907-105843-60b5.png',
  title: 'GIF',
  titleColor: '#E28800',
  linkObjs: [{
    text: '动态表情包',
    url: 'https://www.gaoding.com/templates/fcc1615286-fc1615284-f1612532'
  }, {
    text: '动态二维码',
    url: 'https://www.gaoding.com/templates/fcc1615287-fc1615284-f1612532'
  }, {
    text: '动态文章配图',
    url: 'https://www.gaoding.com/templates/fcc1615291-fc1615284-f1612532'
  }, {
    text: '动态分割线',
    url: 'https://www.gaoding.com/templates/fcc1615292-fc1615284-f1612532'
  }, {
    text: '更多',
    url: 'https://www.gaoding.com/templates/fc1615284-f1612532'
  }]
}, {
  img: 'https://st-gdx.dancf.com/gaodingx/213/configs/system/20200907-110140-7e06.png',
  title: '印刷物料',
  titleColor: '#663EDA',
  linkObjs: [{
    text: '宣传单',
    url: 'https://www.gaoding.com/templates/fcc1615325-fc1615323-f1612532'
  }, {
    text: '名片',
    url: 'https://www.gaoding.com/templates/fcc1615326-fc1615323-f1612532'
  }, {
    text: '画册',
    url: 'https://www.gaoding.com/templates/fcc1615329-fc1615323-f1612532'
  }, {
    text: '三折页',
    url: 'https://www.gaoding.com/templates/fcc1615331-fc1615323-f1612532'
  }, {
    text: '更多',
    url: 'https://www.gaoding.com/templates/fc1615323-f1612532'
  }]
}];